const DUPLICATE_EMAIL_PATTERNS = [
  'email already',
  'account with this email',
  'already registered',
  'duplicate email',
];

export const DUPLICATE_EMAIL_USER_MESSAGE =
  'This email is already registered. Sign in with this email, or use a different one to create a new account.';

export function isDuplicateEmailMessage(message: string): boolean {
  const lower = message.toLowerCase();
  return DUPLICATE_EMAIL_PATTERNS.some((pattern) => lower.includes(pattern));
}

/** Normalize signup API / auth errors into a user-facing message. */
export function parseSignupError(error: unknown): {
  message: string;
  isDuplicateEmail: boolean;
} {
  let raw = '';

  if (error && typeof error === 'object') {
    const axiosLike = error as {
      response?: { data?: { message?: string } };
      message?: string;
    };
    const apiMessage = axiosLike.response?.data?.message;
    if (typeof apiMessage === 'string' && apiMessage.trim()) {
      raw = apiMessage.trim();
    } else if (error instanceof Error && error.message.trim()) {
      raw = error.message.trim();
    }
  } else if (error instanceof Error) {
    raw = error.message.trim();
  }

  if (!raw) {
    return { message: 'Sign up failed. Please try again.', isDuplicateEmail: false };
  }

  if (isDuplicateEmailMessage(raw)) {
    return { message: DUPLICATE_EMAIL_USER_MESSAGE, isDuplicateEmail: true };
  }

  return { message: raw, isDuplicateEmail: false };
}
